<template>
  <section>
    <dialogModule
      width="1200px"
      top="5"
      :title="$t('deptCollectMoney.ticketGoodDialogTitle')"
      v-if="ticketGoodVisible"
      :dialogVisible="ticketGoodVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="closeTicket('check')">
      <span slot="close" class="el-icon-close close cursor" @click="closeTicket('check')"></span>
      <section slot="content" class="content row" v-loading="loading">
        <div class="left">
          <div class="ticket" v-if="couponInfo">
            <div class="row align-center source-type">
              <div class="row align-center">
                {{ $t('deptCollectMoney.ticketGoodSource') }}
                <img class="source-img" v-if="couponInfo.channel === '1'" src="@/assets/images/douyin.png" />
                <img class="source-img" v-if="couponInfo.channel === '2'" src="@/assets/images/kuaishou.png" />
                <img class="source-img" v-if="couponInfo.channel === '3'" src="@/assets/images/wxchat.png" />
                {{couponInfo.channelName}}
              </div>
              <div>
                {{ $t('deptCollectMoney.ticketGoodType') }}<span>{{ couponInfo.couponTypeName }}</span>
              </div>
            </div>
            <div class="title">{{ couponInfo.name }}</div>
            <div class="time">{{ $t('deptCollectMoney.ticketGoodValidity') }}{{ couponInfo.startTime }} {{ $t('deptCollectMoney.ticketToDate') }} {{ couponInfo.expireTime }}</div>
            <span v-if="type == 'check'" class="recheck" @click="closeTicket('recheck')">{{ $t('deptCollectMoney.ticketGoodReScanCode') }}</span>
          </div>
          <div class="row align-center space-between scan-goods">
            <div class="scan-input">
              <input
                type="text"
                ref="ticketInput"
                v-focusInput="1"
                v-model="searchWord"
                :placeholder="$t('deptCollectMoney.ticketGoodScanPlaceholder')"
                @blur="operateItem('2', '1')"
                @keyup.enter="$event.target.blur()" />
              <i class="iconfont icon-saoma"></i>
            </div>
            <div class="choose-gift" v-if="couponInfo.isHaveGift === 'Y'" @click="giveVisible = true">
              {{ $t('deptCollectMoney.ticketGoodChooseGift', { giftNumLimit: couponInfo.giftNumLimit }) }}
            </div>
          </div>
          <div class="goods-box">
            <div class="section" v-if="couponInfo.couponType == '1'">
              <p class="title">{{ $t('deptCollectMoney.ticketGoodDeductTagPrice', { tagTriceAmount: couponInfo.tagTriceAmount }) }}</p>
              <div
                class="goods-list row space-between flex-wrap"
                v-if="currentTicket.goodInfos && currentTicket.goodInfos.length">
                <div class="goods-card row" v-for="(item, index) in currentTicket.goodInfos" :key="index">
                  <div class="goods-left row">
                    <div class="goods-img row align-center space-center">
                      <el-image
                        class="img"
                        v-if="item.imageList.length"
                        :src="item.imageList[0]"
                        :preview-src-list="item.imageList"></el-image>
                      <div v-else>{{ $t('deptCollectMoney.noImageText') }}</div>
                    </div>
                    <div>
                      <div class="goods-name">{{ item.goodsName }}</div>
                      <div>{{ item.goodsNo }}</div>
                      <div class="goods-attr">
                        <span>{{ item.attr[0].value }}</span
                        ><span>{{ item.attr[1].value }}</span>
                      </div>
                      <div>{{ $t('deptCollectMoney.ticketGoodAvailableStock') }}{{ item.stock }}</div>
                    </div>
                  </div>
                  <div class="goods-right">
                    <div class="delete" @click="deleGoods(item, index)"><i class="el-icon-delete"></i> {{ $t('deptCollectMoney.ticketGoodDelete') }}</div>
                    <div>{{ $t('deptCollectMoney.ticketGoodTagPriceLabel') }}{{ item.tagPrice }}</div>
                    <div class="price">
                      {{ $t('deptCollectMoney.ticketGoodCurrentRetailPriceLabel') }}<span>{{ item.retailPrice }}</span>
                    </div>
                    <div class="num">
                      <span class="numSub" @click="changeNum(item, index, 'dele', 'goods')">-</span>
                      {{ item.number }}{{ $t('deptCollectMoney.ticketGoodPiece') }}
                      <span class="numSub" @click="changeNum(item, index, 'add', 'goods')">+</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div style="width: 100%; height: 130px; display: flex; justify-content: center; align-items: center">
                  {{ $t('deptCollectMoney.ticketGoodNoGoods') }}
                </div>
              </div>
            </div>
            <div v-else-if="couponInfo.couponType == '2'">
              <div class="section" v-for="(a, adex) in couponInfo.groupInfos" :key="adex">
                <p class="title">{{ indexArr[a.groupSort] + '：' }}{{ a.groupName }}</p>
                <span style="display: block; font-size: 12px; margin-top: -10px; margin-bottom: 10px">
                  {{ a.groupDesc }}</span
                >
                <div
                  class="goods-list row space-between flex-wrap"
                  v-if="currentTicket.goodInfos && currentTicket.goodInfos.length">
                  <template v-for="(item, index) in currentTicket.goodInfos">
                    <div class="goods-card row" :key="index" v-if="item.groupId == a.groupId">
                      <div class="goods-left row">
                        <div class="goods-img row align-center space-center">
                          <el-image
                            class="img"
                            v-if="item.imageList.length"
                            :src="item.imageList[0]"
                            :preview-src-list="item.imageList"></el-image>
                          <div v-else>{{ $t('deptCollectMoney.noImageText') }}</div>
                        </div>
                        <div>
                          <div class="goods-name">{{ item.goodsName }}</div>
                          <div>{{ item.goodsNo }}</div>
                          <div class="goods-attr">
                            <span>{{ item.attr[0].value }}</span
                            ><span>{{ item.attr[1].value }}</span>
                          </div>
                          <div>{{ $t('deptCollectMoney.ticketGoodAvailableStock') }}{{ item.stock }}</div>
                        </div>
                      </div>
                      <div class="goods-right">
                        <div class="delete" @click="deleGoods(item, index)"><i class="el-icon-delete"></i> {{ $t('deptCollectMoney.ticketGoodDelete') }}</div>
                        <div>{{ $t('deptCollectMoney.ticketGoodTagPriceLabel') }}{{ item.tagPrice }}</div>
                        <div class="price">
                          {{ $t('deptCollectMoney.ticketGoodCurrentRetailPriceLabel') }}<span>{{ item.retailPrice }}</span>
                        </div>
                        <div class="num">
                          <span class="numSub" @click="changeNum(item, index, 'dele', 'goods')">-</span>
                          {{ item.number }}{{ $t('deptCollectMoney.ticketGoodPiece') }}
                          <span class="numSub" @click="changeNum(item, index, 'add', 'goods')">+</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div v-if="ifCard(a)">
                  <div style="width: 100%; height: 130px; display: flex; justify-content: center; align-items: center">
                    {{ $t('deptCollectMoney.ticketGoodNoGoods') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="section">
              <p class="title">{{ $t('deptCollectMoney.ticketGoodGift') }}</p>
              <div
                class="goods-list row space-between flex-wrap"
                v-if="currentTicket.giftGoodInfos && currentTicket.giftGoodInfos.length">
                <div class="goods-card row" v-for="(item, index) in currentTicket.giftGoodInfos" :key="index">
                  <div class="goods-left row">
                    <div class="goods-img row align-center space-center">
                      <el-image
                        class="img"
                        v-if="item.imageList.length"
                        :src="item.imageList[0]"
                        :preview-src-list="item.imageList"></el-image>
                      <div v-else>{{ $t('deptCollectMoney.noImageText') }}</div>
                    </div>
                    <div>
                      <div class="goods-name">{{ item.goodsName }}</div>
                      <div>{{ item.goodsNo }}</div>
                      <div class="goods-attr">
                        <span>{{ item.attr[0].value }}</span
                        ><span>{{ item.attr[1].value }}</span>
                      </div>
                      <div>{{ $t('deptCollectMoney.ticketGoodAvailableStock') }}{{ item.stock }}</div>
                    </div>
                  </div>
                  <div class="goods-right">
                    <div class="delete" @click="deleGoods(item, index, 'gift')">
                      <i class="el-icon-delete"></i> {{ $t('deptCollectMoney.ticketGoodDelete') }}
                    </div>
                    <div>{{ $t('deptCollectMoney.ticketGoodTagPriceLabel') }}{{ item.tagPrice }}</div>
                    <div class="price">
                      {{ $t('deptCollectMoney.ticketGoodCurrentRetailPriceLabel') }}<span>{{ item.retailPrice }}</span>
                    </div>
                    <div class="num">
                      <span class="numSub" @click="changeNum(item, index, 'dele', 'gift')">-</span>
                      {{ item.number }}{{ $t('deptCollectMoney.ticketGoodPiece') }}
                      <span class="numSub" @click="changeNum(item, index, 'add', 'gift')">+</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div style="width: 100%; height: 130px; display: flex; justify-content: center; align-items: center">
                  {{ $t('deptCollectMoney.ticketGoodNoGift') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="right-desc">
            <div class="card-box">
              <p class="label">{{ $t('deptCollectMoney.ticketGoodCouponDesc') }}</p>
              <span>{{ couponInfo.couponRemark }}</span>
            </div>
            <div class="card-box" v-if="couponInfo.couponType == '2'">
              <p class="label">{{ $t('deptCollectMoney.ticketGoodSatisfiedCombination') }}</p>
              <span v-if="!currentTicket.matchFixedCollocationInfos || !currentTicket.matchFixedCollocationInfos.length"
                >{{ $t('deptCollectMoney.ticketGoodNoSatisfiedCombination') }}</span
              >
              <div v-else class="full-group">
                <el-radio-group
                  v-model="pickFixedCollocationSort"
                  style="display: flex; flex-direction: column"
                  @change="operateItem('6', '', '', $t('deptCollectMoney.ticketGoodCombination'))">
                  <el-radio
                    v-for="(item, index) in currentTicket.matchFixedCollocationInfos"
                    :key="index"
                    style="line-height: 30px"
                    :label="item.fixedCollocationSort"
                    ><span v-for="(a, adex) in item.matchFixedCollocationGroupInfos" :key="adex">
                      {{ indexArr[getNumINdex(a.groupId)] }}{{ $t('deptCollectMoney.ticketGoodGroup') }}{{ a.numLimit }}{{ $t('deptCollectMoney.ticketGoodPiece') }}<span
                        v-if="adex !== item.matchFixedCollocationGroupInfos.length - 1">
                        +</span
                      >
                    </span></el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <div class="card-box">
              <p class="label">{{ $t('deptCollectMoney.ticketGoodPriceCalculation') }}</p>
              <div
                v-if="
                  currentTicket.groupGoodsAmountList &&
                  currentTicket.groupGoodsAmountList.length &&
                  currentTicket.couponType === 2
                ">
                <div v-for="(item, index) in currentTicket.groupGoodsAmountList" :key="index">
                  <div style="line-height: 30px" v-if="item.displayFlag == 'Y'">
                    {{ $t('deptCollectMoney.ticketGoodGroupSubtotal', { index: indexArr[item.groupSort], goodsAmount: item.goodsAmount }) }}
                    <span style="color: red;margin-left:30px;" v-if="item.differenceAmount && Number(item.differenceAmount) > 0"
                      >{{ $t('deptCollectMoney.ticketGoodNeedMakeUp', { differenceAmount: item.differenceAmount }) }}</span
                    >
                  </div>
                </div>
              </div>
              <div v-if="currentTicket.couponType === 1" style="margin-top: 15px; font-size: 16px">
                {{ $t('deptCollectMoney.ticketGoodTagPriceTotal', { goodsTagPrice: currentTicket.goodsTagPrice || 0 }) }}
              </div>
              <div v-if="currentTicket.couponType === 2">
                {{ $t('deptCollectMoney.ticketGoodTotal', { goodsRetailPrice: pickFixedCollocationSort ? currentTicket.goodsRetailPrice : 0 }) }}
              </div>
              <div v-if="currentTicket.couponType === 2" style="margin-top: 25px; font-size: 16px">
                {{ $t('deptCollectMoney.ticketGoodTotalReceivable', { realPrice: pickFixedCollocationSort ? currentTicket.realPrice : 0 }) }}
              </div>
              <div v-else style="margin-top: 25px; font-size: 16px">
                {{ $t('deptCollectMoney.ticketGoodTotalReceivable', { realPrice: currentTicket.realPrice || 0 }) }}
              </div>
            </div>
          </div>
          <div class="row align-center space-between right-btn">
            <div class="clear" @click="clearAll">{{ $t('deptCollectMoney.ticketGoodClear') }}</div>
            <el-button
              :disabled="currentTicket.isSatisfy !== 'Y'"
              :class="['sure', currentTicket.isSatisfy === 'Y' ? 'is-active' : '']"
              @click="closeTicket('finish')"
              >{{ type == 'check' ? $t('deptCollectMoney.ticketGoodConfirmCheck') : $t('deptCollectMoney.ticketGoodFinishChoose') }}</el-button
            >
          </div>
        </div>
      </section>
    </dialogModule>

    <TicketGive
      v-if="giveVisible"
      @close="giveVisible = false"
      :couponInfoList="ticketList"
      :couponInfo="currentTicket"
      type="1"
      @gift="gift"></TicketGive>
  </section>
</template>

<script>
import eventBus from '@/bus/index.js'
import TicketGive from './TicketGive.vue'
import dialogModule from '@/components/dialogModule.vue'
import { operateGoodsNo } from '@/libs/http/modules/posOrder.js'
export default {
  components: {
    TicketGive,
    dialogModule
  },
  props: {
    goodsList: {
      //货品列表
      type: Array,
      default: () => []
    },
    couponInfo: {
      //当前操作的券
      type: Object,
      default: () => {}
    },
    couponInfoList: {
      //券列表
      type: Array,
      default: () => []
    },
    type: {
      //check第一次选货品 choose重选货品  changeType重选核销类型
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      pickFixedCollocationSort: '',
      currentTicket: {},
      ticketList: [],
      giveVisible: false,
      ticketGoodVisible: true,
      indexArr: ['A', 'B', 'C', 'D', 'E', 'F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
      searchWord: '',
      isUpdatePrice: true,
      loading: false,
      isChangeData: false,
      currentTicket1: {}
    }
  },
  created() {
    this.ticketList = []
    this.currentTicket = this.couponInfo
    if (this.couponInfoList.length) {
      let index = this.couponInfoList.findIndex(item => {
        return item.certificateId === this.couponInfo.certificateId
      })
      if (index === -1) {
        this.ticketList = [...this.couponInfoList, ...[this.couponInfo]]
      } else {
        // this.ticketList = this.couponInfoList
        // 重选核销类型时换成该券的其他类型
        let list = JSON.parse(JSON.stringify(this.couponInfoList))
        list.splice(index, 1, this.couponInfo)
        this.ticketList = list
      }
    } else {
      this.ticketList = [this.couponInfo]
    }

    this.$nextTick(() => {
      this.$refs.ticketInput.focus()
    })
    this.currentTicket1 = JSON.parse(JSON.stringify(this.currentTicket))

    if (this.currentTicket && this.currentTicket.pickFixedCollocationSort) {
      this.pickFixedCollocationSort = this.currentTicket.pickFixedCollocationSort
    }
  },
  methods: {
    changeNum(item, index, changeType, type) {
      let rowData = item
      rowData['index'] = index
      const addMinusText = this.$t('deptCollectMoney.ticketGoodAddMinus')
      if (type && type == 'gift') {
        if (changeType == 'dele') {
          this.operateItem('1', '2', rowData, addMinusText)
        } else {
          this.operateItem('1', '1', rowData, addMinusText)
        }
      } else {
        if (changeType == 'dele') {
          this.operateItem('2', '2', rowData, addMinusText)
        } else {
          this.operateItem('2', '1', rowData, addMinusText)
        }
      }
    },
    getNumINdex(id) {
      let adex = ''
      if (this.couponInfo.groupInfos) {
        this.couponInfo.groupInfos.forEach((item, index) => {
          if (id == item.groupId) {
            adex = index
          }
        })
        return adex
      }
    },
    ifCard(a) {
      let ifShow = false
      let list = []
      if (this.currentTicket && this.currentTicket.goodInfos && this.currentTicket.goodInfos.length) {
        list = this.currentTicket.goodInfos.map(item => {
          return item.groupId
        })
      }
      if (!list.includes(a.groupId)) {
        ifShow = true
      }
      return ifShow
    },
    gift(data, list) {
      this.isChangeData = true
      this.ticketList = list
      this.currentTicket = data
    },
    //删除
    deleGoods(item, index, type) {
      this.$confirm(this.$t('deptCollectMoney.ticketGoodConfirmDeleteGoods'), this.$t('deptCollectMoney.ticketGoodTip'))
        .then(res => {
          let rowData = item
          rowData['index'] = index
          if (type && type == 'gift') {
            this.operateItem('1', '4', rowData)
          } else {
            this.operateItem('2', '4', rowData)
          }
        })
        .catch(() => {})
    },
    scanInputFocus() {
      this.$nextTick(() => {
        this.$refs.ticketInput.focus()
      })
    },
    operateItem(operationCouponType = '2', alterGoodsWay = '1', rowData, type) {
      // this.scanInputFocus()
      //操作列表货品
      const addMinusText = this.$t('deptCollectMoney.ticketGoodAddMinus')
      const combinationText = this.$t('deptCollectMoney.ticketGoodCombination')
      if (!this.searchWord && operationCouponType === '2' && alterGoodsWay === '1' && type !== addMinusText) {
        return
        // return this.$message({ showClose: true, type: 'error', message: this.$t('deptCollectMoney.ticketGoodPleaseScan'), duration: 2000 })
      }
      this.loading = true
      if (operationCouponType == '7' && type == 'check') {
        const andIdx = this.ticketList.findIndex(item => {
          return (item.certificateId = this.currentTicket.certificateId)
        })
        if (andIdx !== -1) {
          this.ticketList.splice(andIdx, 1, this.currentTicket1)
        }
      }
      let reqData = {
        type: '6',
        couponInfoList: this.ticketList
      }
      if (operationCouponType === '2' && alterGoodsWay === '1' && type !== addMinusText) {
        //添加货品
        reqData['operateCouponsGoodInfo'] = {
          alterGoodsWay: '1',
          barCode: this.searchWord,
          certificateId: this.couponInfo.certificateId,
          operationCouponType: '2'
        }
      }

      if (type === addMinusText) {
        //加减货品
        reqData['operateCouponsGoodInfo'] = {
          alterGoodsWay: alterGoodsWay,
          barCode: rowData.barCode,
          index: rowData.index,
          certificateId: this.couponInfo.certificateId,
          operationCouponType: operationCouponType
        }
      }

      if ((operationCouponType === '2' || operationCouponType === '1') && alterGoodsWay === '4' && rowData) {
        //删除货品
        reqData['operateCouponsGoodInfo'] = {
          alterGoodsWay: '4',
          barCode: rowData.barCode,
          index: rowData.index,
          certificateId: this.couponInfo.certificateId,
          operationCouponType: operationCouponType
        }
      }

      //重扫券码或第一次打开选品弹窗点x关闭（撤销核销）
      if (['5', '6'].includes(operationCouponType) && type !== combinationText) {
        reqData['operateCouponsGoodInfo'] = {
          operationCouponType: '5',
          certificateId: this.couponInfo.certificateId
        }
      }

      //固定搭配时选择组别
      if (operationCouponType == '6' && type == combinationText) {
        reqData['operateCouponsGoodInfo'] = {
          operationCouponType: '6',
          certificateId: this.couponInfo.certificateId,
          pickFixedCollocationSort: this.pickFixedCollocationSort
        }
      }

      //清空
      if (operationCouponType === '2' && alterGoodsWay === '6') {
        reqData['operateCouponsGoodInfo'] = {
          alterGoodsWay: alterGoodsWay,
          certificateId: this.couponInfo.certificateId,
          operationCouponType: '2'
        }
      }

      if (operationCouponType === '7') {
        reqData['operateCouponsGoodInfo'] = {
          operationCouponType: '4',
          certificateId: this.couponInfo.certificateId
        }
        if(this.type === 'changeType'){
          reqData['goodInfos'] = this.goodsList.filter(item => {
            return !(item.operationType === '2' && item.certificateId === this.couponInfo.certificateId)
          })
        }else{
          reqData['goodInfos'] = this.goodsList
        }
      }

      operateGoodsNo(reqData)
        .then(data => {
          this.searchWord = ''

          if (data) {
            let currentNum = 0

            if (this.currentTicket && this.currentTicket.goodInfos && this.currentTicket.goodInfos.length) {
              this.currentTicket.goodInfos.forEach(item => {
                currentNum += Number(item.number)
              })
            }

            this.ticketList = data.couponGoodInfos
            this.currentTicket = this.ticketList.find(item => {
              return item.certificateId == this.currentTicket.certificateId
            })

            let currentNum2 = 0

            if (this.currentTicket && this.currentTicket.goodInfos && this.currentTicket.goodInfos.length) {
              this.currentTicket.goodInfos.forEach(item => {
                currentNum2 += Number(item.number)
              })
            }
            if (
              this.currentTicket &&
              this.currentTicket.matchFixedCollocationInfos &&
              this.currentTicket.matchFixedCollocationInfos.length
            ) {
              if (this.currentTicket && this.currentTicket.goodInfos && this.currentTicket.goodInfos.length) {
                if (currentNum !== currentNum2) {
                  this.pickFixedCollocationSort = this.currentTicket.matchFixedCollocationInfos[0].fixedCollocationSort
                }
              }
            } else {
              this.pickFixedCollocationSort = ''
            }
          }

          if (['5', '6', '7'].includes(operationCouponType) && type !== combinationText) {
            this.ticketGoodVisible = false
            if (operationCouponType === '5') {
              this.$emit('closeDialog', 'recheck')
            } else {
              this.$emit('closeDialog')
            }
          } else {
            this.scanInputFocus()
          }
          if (operationCouponType === '7') {
            this.ticketGoodVisible = false
            this.$emit('closeDialog', data)
            if (this.type === 'choose') {
              eventBus.$emit('send', this.ticketList)
            }
          }

          this.searchWord = ''
          this.loading = false
          this.isChangeData = true
        })
        .catch(error => {
          this.searchWord = ''
          this.loading = false
          this.scanInputFocus()
          //只有扫码才会有声音
          if (operationCouponType === '2' && alterGoodsWay === '1' && type !== addMinusText && this.searchWord) {
            this.$store.commit('playErrorAudio')
          }
          this.$message({ showClose: true, type: 'error', message: error, duration: 2000 })
        })
    },
    closeTicket(type) {
      this.currentTicket['pickFixedCollocationSort'] = this.pickFixedCollocationSort
      if ((this.type === 'check' && type === 'check') || type === 'recheck') {
        if (type === 'recheck') {
          this.operateItem('5')
        } else {
          this.operateItem('6')
        }
      } else {
        if(this.type === 'changeType'){
          if(type === 'finish' && this.isChangeData){
            this.operateItem('7', '', '', type)
          }else{
            this.ticketGoodVisible = false
            this.$emit('closeDialog')
          }
        }else{
          if (this.isChangeData) {
            this.operateItem('7', '', '', type)
          } else {
            this.ticketGoodVisible = false
            this.$emit('closeDialog')
          }
        }
      }
    },
    clearAll() {
      if (
        (!this.currentTicket.goodInfos || !this.currentTicket.goodInfos.length) &&
        (!this.currentTicket.giftGoodInfos || !this.currentTicket.giftGoodInfos.length)
      ) {
        return this.$message.error(this.$t('deptCollectMoney.ticketGoodNoGoodsOrGift'))
      }
      this.$confirm(this.$t('deptCollectMoney.ticketGoodConfirmClearGoods'), this.$t('deptCollectMoney.ticketGoodTip'))
        .then(res => {
          this.operateItem('2', '6')
        })
        .catch(error => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 85vh;
  .left {
    flex: 1;
    margin: 10px 20px 0;
    .ticket {
      padding: 10px;
      border-radius: 4px;
      position: relative;
      background: #f5f7fa;
      .source-type {
        div {
          img {
            width: 14px;
            margin-right: 5px;
            border-radius: 4px;
          }
          &:last-child {
            margin-left: 50px;
            span{
              font-size: 18px;
              font-weight: bolder;
              color: #722ed1;
              padding: 2px 5px;
              border-radius: 2px;
            }
          }
        }
      }
      .title {
        color: #333;
        margin: 10px 0;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
      }
      .time {
        color: #666;
      }
      .recheck {
        top: 5px;
        right: 10px;
        color: #f8475f;
        font-size: 16px;
        cursor: pointer;
        font-weight: bold;
        position: absolute;
      }
    }
    .scan-goods {
      margin-top: 20px;
      .scan-input {
        height: 40px;
        line-height: 40px;
        border-radius: 8px;
        border: 1px solid orange;
        input {
          width: 260px;
          line-height: 36px;
          height: 36px;
          outline: none;
          margin-left: 10px;
          font-size: 14px;
          float: left;
          border: none;
          margin-top: 2px;
          background: none;
          color: orange;
          padding-right: 10px;
        }
        i {
          color: orange;
          font-size: 20px;
          font-weight: bold;
          margin-right: 10px;
        }
        input::-webkit-input-placeholder {
          color: #666;
        }
        input:focus {
          color: #c56209;
        }
        input:focus::-webkit-input-placeholder {
          color: #c56209;
        }
      }
      .choose-gift {
        color: #077cf2;
        cursor: pointer;
        padding: 0 20px;
        line-height: 30px;
        border-radius: 4px;
        background: #e6f7ff;
        border: 1px solid #077cf2;
      }
    }
    .goods-box {
      margin-top: 20px;
      max-height: 76%;
      overflow-y: scroll;
      .section {
        margin-bottom: 15px;
        .title {
          color: #000;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .goods-list {
          overflow-y: scroll;
          max-height: 260px;
          .goods-card {
            padding: 8px;
            border-radius: 4px;
            background: #f5f7fa;
            margin-bottom: 10px;
            width: calc((100% - 10px) / 2);
            height: 110px;
            .goods-left {
              .goods-img {
                width: 90px;
                height: 90px;
                border-radius: 4px;
                margin-right: 10px;
                background: #e5e5e5;
                .img {
                  width: 90px;
                  height: 90px;
                  cursor: pointer;
                  border-radius: 4px;
                }
              }
              .goods-name {
                color: #000;
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 5px;
              }
              .goods-attr {
                margin: 5px 0;
                span {
                  padding: 0 8px;
                  font-size: 12px;
                  margin-right: 5px;
                  border-radius: 2px;
                  border: 1px solid #aaa;
                }
              }
            }
            .goods-right {
              flex: 1;
              margin-left: 20px;
              text-align: right;
              .delete {
                color: #f8475f;
                cursor: pointer;
                margin-bottom: 5px;
                display: inline-block;
              }
              .price {
                margin: 5px 0;
                span {
                  color: #000;
                }
              }
              .num {
                color: #077cf2;
                font-weight: bold;
                .numSub {
                  cursor: pointer;
                  display: inline-block;
                  font-size: 14px;
                  width: 24px;
                  height: 18px;
                  background: #077cf2;
                  color: #fff;
                  line-height: 18px;
                  text-align: center;
                  border-radius: 3px;
                }
              }
            }
          }
        }
      }
    }
  }

  .right {
    width: 360px;
    .right-desc {
      height: 77vh;
      overflow-y: scroll;
      padding: 10px;
      border-radius: 8px;
      background: #fff7e6;
      margin: 10px 20px 20px 0;
      .card-box {
        margin-bottom: 20px;
        .label {
          color: #000;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
      }
    }
    .right-btn {
      margin-top: 20px;
      .clear {
        color: #000;
        width: 100px;
        cursor: pointer;
        font-size: 16px;
        line-height: 36px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #aaa;
      }
      .sure {
        flex: 1;
        color: #fff;
        height: 40px;
        margin: 0 20px;
        border-radius: 4px;
        text-align: center;
        background: #bfbfbf;
      }
      .is-active {
        background: #0b83f3;
      }
    }
  }
}
</style>
